export default __webpack_public_path__ + "static/media/head01_ja_sp.296df087.png";